import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdminActionButton } from '../../../../Component/UI/AdminPageHeader';
import LiveDetailDialog from './LiveDetailDialog';

export default function RehearsalEndedNotice() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(!!state?.rehearsalEnded);
  useEffect(() => {
    if (state?.rehearsalEnded) navigate('.', { replace: true, state: null });
  }, [state, navigate]);

  return <LiveDetailDialog footer={<AdminActionButton $primary type="button" onClick={() => setOpen(false)}>확인</AdminActionButton>} open={open} size="compact" title="리허설이 종료되었습니다"
    description="예약 시작 5분 전이 되어 리허설을 종료하고 목록으로 돌아왔습니다. 이제 라이브를 시작할 수 있습니다."
    closeOnlyByButton onClose={() => setOpen(false)}>
    
  </LiveDetailDialog>;
}
